import '../../../css/discord.scss';
import '../../../css/leaderboard.scss';
import { EntryHomepage, uiManager } from '../../EntryHomepage.ts';
import { UIDLoadingScreen } from '../../../../shared/scripts/discord/UIDLoadingScreen.ts';
import { DiscordInstance } from '../DiscordInstance.ts';
import { DiscordLinkInterceptor } from '../../../../shared/scripts/discord/DiscordLinkInterceptor.ts';
import { SDKRequest } from '../../../../../shared/DiscordActivityTypes.ts';
import { UISingletonScrollController } from '../../../../shared/scripts/ui_scroll_controller/UISingletonScrollController.ts';
import { Scene } from '../../ui_html/UISceneTypes.ts';
import { UIPopupManager } from '../../../../shared/scripts/ui_popup/UIPopupManager.ts';
import { getValidSubPath, isValidPath, stripLanguagePrefix, SceneSubPathType, stripProxyPrefix } from '../utils/ValidLinks.ts';
import { FAQ_URL, MAX_USERNAME_LENGTH } from '@colonist/consts';
import { UIUrlController, UIUrlParameterNames } from '../../../../shared/scripts/ui_html/UIUrlController.ts';
import { StorageWrapper } from '../../../../shared/scripts/StorageWrapper.ts';
import { showSimpleDialog } from '../../../../shared/scripts/ui_popup/showSimpleDialog.ts';
import { UIDConsoleLog } from './components/UIDConsoleLog.ts';
import { LobbyImage } from '@colonist/types';
import { getHomepageUrlWithParameter, navigateToPage } from '../../../../shared/scripts/ui_utils/ClientUtils.ts';
import { UIEntryUrlParameterController } from '../../../../shared/scripts/UIEntryUrlParameterController.ts';
import { SocketDiscordActionController } from './SocketDiscordActionController.ts';
import { socket, uiGameManager } from '../../../../shared/scripts/EntryShared.ts';
import { registerDiscordRoomClientHandlers } from './DiscordRoomClientHandlers.ts';
import { ClientUserState } from '../../../../shared/scripts/ClientUserState.ts';
import { UIAjaxWrapper } from '../../../../shared/scripts/network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../../../shared/scripts/network/UIAPIEndpoints.ts';
import { ShareActivityLinkAnalytics } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { showPushReferrersToInviteMoreFriendsDialog } from '../../ui_popup/showPushReferrersToInviteMoreFriendsDialog.ts';
import { SDKRequestHandler } from './sdk_requests/SDKRequestHandler.ts';
import { UIGameEndFooterController } from '../../../../shared/scripts/ui_game/ui_game_end_screen/UIGameEndFooterController.ts';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
const PUSH_REFERRERS_TO_INVITE_MORE_PLAYERS_MINIMUM_REFERRAL_COUNT = 1;
const PUSH_REFERRERS_TO_INVITE_MORE_PLAYERS_MAXIMUM_REFERRAL_COUNT = 4;
export class EntryDiscordContentFrame extends EntryHomepage {
    async initialize() {
        new UIDConsoleLog();
        this.discordInstance = DiscordInstance.getDiscordInstance();
        await this.discordInstance.init(new UIDLoadingScreen());
        await super.initialize();
        registerDiscordRoomClientHandlers(socket.roomClient);
        this.registerDiscordScenes();
        EntryDiscordContentFrame.initDiscordControllers();
        this.linkInterceptor = new DiscordLinkInterceptor((url)=>this.discordInstance.sendSDKRequest(SDKRequest.OpenExternalLink, url), (link)=>this.handleLinkNavigation(link));
        this.linkInterceptor.init();
        EntryDiscordContentFrame.displayAccountLinkedPopup();
        this.setServerProfileOnHeader();
        void this.discordInstance.handlePendingPurchases();
        this.displayPushReferrersToInviteMoreFriendsPopup();
    }
    displayPushReferrersToInviteMoreFriendsPopup() {
        this.removeChangeListener = ClientUserState.registerChangeListener(()=>{
            // Defer execution to next tick to ensure assignment to this.removeChangeListener is complete
            setTimeout(async ()=>{
                if (ClientUserState.haveAbTestsLoaded == false) return;
                this.removeChangeListener();
                if (EntryDiscordContentFrame.shouldShowInviteFriendsPopup()) {
                    var _data_json;
                    const data = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiGetUserReferralCount(), undefined);
                    var _data_json_referralCount;
                    const referralCount = (_data_json_referralCount = data === null || data === void 0 ? void 0 : (_data_json = data.json) === null || _data_json === void 0 ? void 0 : _data_json.referralCount) !== null && _data_json_referralCount !== void 0 ? _data_json_referralCount : 0;
                    if (!EntryDiscordContentFrame.isReferralCountInRange(referralCount)) return;
                    showPushReferrersToInviteMoreFriendsDialog(referralCount);
                    SDKRequestHandler.sendShareActivityLinkAnalytic(ShareActivityLinkAnalytics.ABTestPushReferrersToInviteMorePlayersGroupCPrePopupTriggered);
                    StorageWrapper.setLastPushReferrersToInviteMoreFriendsPopupTime(new Date());
                }
            }, 0);
        });
    }
    static shouldShowInviteFriendsPopup() {
        const lastPushReferrersToInviteMoreFriendsPopupTime = StorageWrapper.getLastPushReferrersToInviteMoreFriendsPopupTime();
        if (UIGameEndFooterController.popupWasShownInLastTwentyFourHours(lastPushReferrersToInviteMoreFriendsPopupTime)) return false;
        return true;
    }
    static isReferralCountInRange(referralCount) {
        if (referralCount < PUSH_REFERRERS_TO_INVITE_MORE_PLAYERS_MINIMUM_REFERRAL_COUNT) return false;
        if (referralCount > PUSH_REFERRERS_TO_INVITE_MORE_PLAYERS_MAXIMUM_REFERRAL_COUNT) return false;
        return true;
    }
    registerDiscordScenes() {
        this.discordScenes = new Map();
        this.discordScenes.set('/leaderboards', [
            Scene.DiscordLeaderboard,
            UIUrlParameterNames.DiscordLeaderboard
        ]);
        this.discordScenes.set('/store', [
            Scene.DiscordStore,
            UIUrlParameterNames.DiscordStore
        ]);
        this.discordScenes.set('/about', [
            Scene.DiscordAbout,
            UIUrlParameterNames.DiscordAbout
        ]);
        this.discordScenes.set('/careers', [
            Scene.DiscordCareers,
            UIUrlParameterNames.DiscordCareers
        ]);
        this.discordScenes.set('/championship2025', [
            Scene.DiscordChampionship25,
            UIUrlParameterNames.DiscordChampionship25
        ]);
        this.discordScenes.set('/championship2026', [
            Scene.DiscordChampionship26,
            UIUrlParameterNames.DiscordChampionship26
        ]);
        this.discordScenes.set('/community', [
            Scene.DiscordCommunity,
            UIUrlParameterNames.DiscordCommunity
        ]);
        this.discordScenes.set('/faq', [
            Scene.DiscordFAQ,
            UIUrlParameterNames.DiscordFAQ
        ]);
        this.discordScenes.set('/privacy-policy', [
            Scene.DiscordPrivacyPolicy,
            UIUrlParameterNames.DiscordPrivacyPolicy
        ]);
        this.discordScenes.set('/patch-notes', [
            Scene.DiscordPatchNotes,
            UIUrlParameterNames.DiscordPatchNotes
        ]);
        this.discordScenes.set('/values-examples', [
            Scene.DiscordValuesExamples,
            UIUrlParameterNames.DiscordValuesExamples
        ]);
        this.discordScenes.set('/values', [
            Scene.DiscordValues,
            UIUrlParameterNames.DiscordValues
        ]);
        this.discordScenes.set('/terms', [
            Scene.DiscordTerms,
            UIUrlParameterNames.DiscordTerms
        ]);
        this.discordScenes.set('/press-kit', [
            Scene.DiscordPressKit,
            UIUrlParameterNames.DiscordPressKit
        ]);
        this.discordScenes.set('/refund-policy', [
            Scene.DiscordRefundPolicy,
            UIUrlParameterNames.DiscordRefundPolicy
        ]);
        this.discordScenes.set('/more', [
            Scene.DiscordMore,
            UIUrlParameterNames.DiscordMore
        ]);
    }
    static initDiscordControllers() {
        new UISingletonScrollController('scene_discord_store_container');
        new UISingletonScrollController('scene_discord_about_container');
        new UISingletonScrollController('scene_discord_community_container');
        new UISingletonScrollController('scene_discord_privacy_policy_container');
        new UISingletonScrollController('scene_discord_patch_notes_container');
        new UISingletonScrollController('scene_discord_terms_container');
        new UISingletonScrollController('scene_discord_press_kit_container');
        new UISingletonScrollController('scene_discord_refund_policy_container');
    }
    static displayAccountLinkedPopup() {
        const wasAccountLinked = StorageWrapper.getDiscordAccountLinked();
        if (!wasAccountLinked) return;
        showSimpleDialog({
            title: {
                key: 'strings:homePage.popups.discordAccountLinked.title'
            },
            body: {
                key: 'strings:homePage.popups.discordAccountLinked.body'
            }
        });
        StorageWrapper.removeDiscordAccountLinked();
    }
    setServerProfileOnHeader() {
        const headerUsername = this.getUsernameForHeader();
        uiManager.headerProfile.discordUserStateOverrides = {
            username: headerUsername,
            profilePictureUrl: this.discordInstance.serverProfile.profilePictureUrl,
            icon: LobbyImage.Guest,
            karmaStatus: {
                key: 'strings:colonistCommon.utils.emptyString'
            }
        };
    }
    handleLinkNavigation(link) {
        if (link.startsWith('/#')) {
            const hash = link.substring(2);
            if (hash == `${UIUrlParameterNames.MainPage}=${UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE}`) {
                uiManager.sceneController.loadScene(Scene.MainPage);
                return true;
            }
        }
        if (link.startsWith('#')) {
            const hash = link.substring(1);
            if (hash) {
                const elementToScrollTo = document.getElementById(hash);
                elementToScrollTo === null || elementToScrollTo === void 0 ? void 0 : elementToScrollTo.scrollIntoView({
                    behavior: 'smooth'
                });
            }
            return true;
        }
        if (link.includes('#')) {
            const hashPart = link.split('#')[1];
            if (hashPart) {
                const urlParams = new URLSearchParams(hashPart);
                let handled = false;
                if (urlParams.get(UIUrlParameterNames.EnterMatchmaking) === String(MatchmakingMatchTypes.UnrankedShuffle)) {
                    uiManager.header.notificationPanelController.hideNotificationPanel();
                    void uiManager.goToMainPageAndSelectMatchType(MatchmakingMatchTypes.UnrankedShuffle);
                    handled = true;
                }
                if (urlParams.has(UIUrlParameterNames.SelectMode)) {
                    const matchType = urlParams.get(UIUrlParameterNames.SelectMode);
                    UIPopupManager.closeAllPopups();
                    void uiManager.goToMainPageAndSelectMatchType(matchType);
                    handled = true;
                }
                if (urlParams.get(UIUrlParameterNames.SuppressPopupsOnLoad) === UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE) {
                    UIEntryUrlParameterController.suppressPopupsOnLoad = true;
                    handled = true;
                }
                if (handled) return true;
            }
        }
        const strippedProxyLink = stripProxyPrefix(link);
        const strippedProxyAndLanguageLink = stripLanguagePrefix(strippedProxyLink);
        const subPath = getValidSubPath(strippedProxyAndLanguageLink);
        if (subPath != undefined) {
            switch(subPath.name){
                case SceneSubPathType.Profile:
                    const profileData = subPath.extractData(strippedProxyAndLanguageLink);
                    if (profileData == undefined) return false;
                    const username = profileData[0];
                    if (uiManager.sceneController.scene == Scene.Room) {
                        uiManager.room.leaveRoom(Scene.DiscordProfile, {
                            username: username
                        });
                    } else {
                        uiManager.sceneController.loadScene(Scene.DiscordProfile, {
                            username: username
                        });
                    }
                    return true;
                case SceneSubPathType.Replay:
                    const replayData = subPath.extractData(strippedProxyAndLanguageLink);
                    if (replayData == undefined) return false;
                    const gameId = replayData[0];
                    const playerColor = replayData[1];
                    uiManager.sceneController.loadScene(Scene.DiscordReplay, {
                        gameId: gameId,
                        playerColor: playerColor
                    });
                    return true;
                case SceneSubPathType.GiftUser:
                    const giftData = subPath.extractData(strippedProxyAndLanguageLink);
                    if (giftData == undefined) return false;
                    const recipientUsername = giftData[0];
                    if (uiManager.sceneController.scene == Scene.Room) {
                        uiManager.room.leaveRoom(Scene.DiscordGifting, {
                            recipientUsername: recipientUsername
                        });
                    } else {
                        uiManager.sceneController.loadScene(Scene.DiscordGifting, {
                            recipientUsername: recipientUsername
                        });
                    }
                    return true;
                default:
                    return false;
            }
        }
        const scene = this.getDiscordScene(link);
        if (scene != undefined) {
            if (scene == '/faq') {
                const { hash: faqHash } = UIUrlController.extractHashAndValue(link);
                this.linkInterceptor.openExternalLink(faqHash ? `${FAQ_URL}#${faqHash}` : FAQ_URL);
                return true;
            }
            const { hash, value } = UIUrlController.extractHashAndValue(link);
            this.loadDiscordScene(scene, hash, value);
            if (hash) {
                const elementToScrollTo = document.getElementById(hash);
                elementToScrollTo === null || elementToScrollTo === void 0 ? void 0 : elementToScrollTo.scrollIntoView({
                    behavior: 'smooth'
                });
            }
            return true;
        }
        if (isValidPath(link)) {
            const fullUrl = 'https://colonist.io' + strippedProxyLink;
            this.linkInterceptor.openExternalLink(fullUrl);
            return true;
        }
        return false;
    }
    getUsernameForHeader() {
        const username = this.discordInstance.serverProfile.username;
        const isUsernameTooLong = username.length > MAX_USERNAME_LENGTH;
        return isUsernameTooLong ? username.substring(0, MAX_USERNAME_LENGTH) : username;
    }
    getDiscordScene(href) {
        const pathname = new URL(href, window.location.origin).pathname;
        const strippedPath = stripLanguagePrefix(stripProxyPrefix(pathname));
        return this.discordScenes.has(strippedPath) ? strippedPath : undefined;
    }
    loadDiscordScene(path, hash, value) {
        const [scene, urlParameter] = this.discordScenes.get(path);
        UIPopupManager.closeAllPopups();
        uiManager.header.closeMobileSidebar();
        if (uiManager.sceneController.scene == Scene.Room) {
            uiManager.room.leaveRoom(scene);
            return true;
        }
        if (uiManager.sceneController.scene == Scene.Game) {
            navigateToPage(getHomepageUrlWithParameter(urlParameter, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE));
            return true;
        }
        uiManager.sceneController.loadScene(scene, {
            hash: hash,
            value: value
        });
        return true;
    }
    // eslint-disable-next-line class-methods-use-this
    createSocketActionController(generalServicesController) {
        return new SocketDiscordActionController(uiGameManager, uiManager, generalServicesController);
    }
    constructor(){
        super();
        void this.initialize();
    }
}
new EntryDiscordContentFrame();
